import React from "react";
import { Text } from "@mantine/core";
import _ from "lodash";
import AccountingJournalSection from "./accountingJournalSection";

const AccountingSourceTab = ({ form, sourceType, title = "Accounting" }) => {
  const entityId = _.get(form, "values._id");

  if (!entityId) {
    return (
      <Text size="sm" color="dimmed">
        Save the document first to view linked journal entries.
      </Text>
    );
  }

  return (
    <AccountingJournalSection
      sourceType={sourceType}
      sourceId={entityId}
      title={title}
    />
  );
};

export default AccountingSourceTab;
